import { render } from "./newforms.vue?vue&type=template&id=0c2a2de8"
import script from "./newforms.vue?vue&type=script&lang=js"
export * from "./newforms.vue?vue&type=script&lang=js"

import "./newforms.vue?vue&type=style&index=0&id=0c2a2de8&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__